import React from "react";
import { useParams, useLocation } from "react-router-dom";
import HalfPageDesign1 from "./design1/HalfPageDesign";
import HalfPageDesign2 from "./design2/HalfPageDesign";
import HalfPageDesign3 from "./design3/HalfPageDesign";
import HalfPageDesign4 from "./design4/HalfPageDesign";
import HalfPageDesign5 from "./design5/HalfPageDesign";
import HalfPageDesign6 from "./design6/HalfPageDesign";
import HalfPageDesign7 from "./design7/HalfPageDesign";
import HalfPageDesign8 from "./design8/HalfPageDesign";
import HalfPageDesign9 from "./design9/HalfPageDesign";
import HalfPageDesign10 from "./design10/HalfPageDesign";

import LeftBarDesign1 from "./design1/LeftBarDesign";
import LeftBarDesign2 from "./design2/LeftBarDesign";
import LeftBarDesign3 from "./design3/LeftBarDesign";
import LeftBarDesign4 from "./design4/LeftBarDesign";
import LeftBarDesign5 from "./design5/LeftBarDesign";
import LeftBarDesign6 from "./design6/LeftBarDesign";
import LeftBarDesign7 from "./design7/LeftBarDesign";
import LeftBarDesign8 from "./design8/LeftBarDesign";
import LeftBarDesign9 from "./design9/LeftBarDesign";
import LeftBarDesign10 from "./design10/LeftBarDesign";

// import pages
import LoginRegister from "./pages/LoginRegister";

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function PreviewV1() {
  const query = useQuery();
  const { name, page } = useParams();

  const getHalfPageDesign = (value) => {
    switch (value) {
      case "design2":
        return (
          <HalfPageDesign2
            gradientcolor={query.get("gradientcolor")}
            landingImage={query.get("theme_landing_image")}
            innerDesign={
              <LoginRegister
                page={value}
                logo={query.get("logo")}
                titlecolor={"#" + query.get("titlecolor")}
                inputlabelcolor={"#" + query.get("inputlabelcolor")}
                inputiconcolor={"#" + query.get("inputiconcolor")}
                inputerrorcolor={"#" + query.get("inputerrorcolor")}
                gradientcolor={query.get("gradientcolor")}
              />
            }
          />
        );
      case "design3":
        return (
          <HalfPageDesign3
            gradientcolor={query.get("gradientcolor")}
            landingImage={query.get("theme_landing_image")}
            innerDesign={
              <LoginRegister
                page={value}
                logo={query.get("logo")}
                titlecolor={"#" + query.get("titlecolor")}
                inputlabelcolor={"#" + query.get("inputlabelcolor")}
                inputiconcolor={"#" + query.get("inputiconcolor")}
                inputerrorcolor={"#" + query.get("inputerrorcolor")}
                gradientcolor={query.get("gradientcolor")}
              />
            }
          />
        );
      case "design4":
        return (
          <HalfPageDesign4
            gradientcolor={query.get("gradientcolor")}
            landingImage={query.get("theme_landing_image")}
            innerDesign={
              <LoginRegister
                page={value}
                logo={query.get("logo")}
                titlecolor={"#" + query.get("titlecolor")}
                inputlabelcolor={"#" + query.get("inputlabelcolor")}
                inputiconcolor={"#" + query.get("inputiconcolor")}
                inputerrorcolor={"#" + query.get("inputerrorcolor")}
                gradientcolor={query.get("gradientcolor")}
              />
            }
          />
        );
      case "design5":
        return (
          <HalfPageDesign5
            gradientcolor={query.get("gradientcolor")}
            landingImage={query.get("theme_landing_image")}
            innerDesign={
              <LoginRegister
                page={value}
                logo={query.get("logo")}
                titlecolor={"#" + query.get("titlecolor")}
                inputlabelcolor={"#" + query.get("inputlabelcolor")}
                inputiconcolor={"#" + query.get("inputiconcolor")}
                inputerrorcolor={"#" + query.get("inputerrorcolor")}
                gradientcolor={query.get("gradientcolor")}
              />
            }
          />
        );
      case "design6":
        return (
          <HalfPageDesign6
            gradientcolor={query.get("gradientcolor")}
            landingImage={query.get("theme_landing_image")}
            innerDesign={
              <LoginRegister
                page={value}
                logo={query.get("logo")}
                titlecolor={"#" + query.get("titlecolor")}
                inputlabelcolor={"#" + query.get("inputlabelcolor")}
                inputiconcolor={"#" + query.get("inputiconcolor")}
                inputerrorcolor={"#" + query.get("inputerrorcolor")}
                gradientcolor={query.get("gradientcolor")}
              />
            }
          />
        );
      case "design7":
        return (
          <HalfPageDesign7
            gradientcolor={query.get("gradientcolor")}
            landingImage={query.get("theme_landing_image")}
            innerDesign={
              <LoginRegister
                page={value}
                logo={query.get("logo")}
                titlecolor={"#" + query.get("titlecolor")}
                inputlabelcolor={"#" + query.get("inputlabelcolor")}
                inputiconcolor={"#" + query.get("inputiconcolor")}
                inputerrorcolor={"#" + query.get("inputerrorcolor")}
                gradientcolor={query.get("gradientcolor")}
              />
            }
          />
        );
      case "design8":
        return (
          <HalfPageDesign8
            gradientcolor={query.get("gradientcolor")}
            landingImage={query.get("theme_landing_image")}
            innerDesign={
              <LoginRegister
                page={value}
                logo={query.get("logo")}
                titlecolor={"#" + query.get("titlecolor")}
                inputlabelcolor={"#" + query.get("inputlabelcolor")}
                inputiconcolor={"#" + query.get("inputiconcolor")}
                inputerrorcolor={"#" + query.get("inputerrorcolor")}
                gradientcolor={query.get("gradientcolor")}
              />
            }
          />
        );
      case "design9":
        return (
          <HalfPageDesign9
            gradientcolor={query.get("gradientcolor")}
            landingImage={query.get("theme_landing_image")}
            innerDesign={
              <LoginRegister
                page={value}
                logo={query.get("logo")}
                titlecolor={"#" + query.get("titlecolor")}
                inputlabelcolor={"#" + query.get("inputlabelcolor")}
                inputiconcolor={"#" + query.get("inputiconcolor")}
                inputerrorcolor={"#" + query.get("inputerrorcolor")}
                gradientcolor={query.get("gradientcolor")}
              />
            }
          />
        );
      case "design10":
        return (
          <HalfPageDesign10
            gradientcolor={query.get("gradientcolor")}
            landingImage={query.get("theme_landing_image")}
            innerDesign={
              <LoginRegister
                page={value}
                logo={query.get("logo")}
                titlecolor={"#" + query.get("titlecolor")}
                inputlabelcolor={"#" + query.get("inputlabelcolor")}
                inputiconcolor={"#" + query.get("inputiconcolor")}
                inputerrorcolor={"#" + query.get("inputerrorcolor")}
                gradientcolor={query.get("gradientcolor")}
              />
            }
          />
        );
      default:
        return (
          <HalfPageDesign1
            gradientcolor={query.get("gradientcolor")}
            landingImage={query.get("theme_landing_image")}
            innerDesign={
              <LoginRegister
                page={value}
                logo={query.get("logo")}
                titlecolor={"#" + query.get("titlecolor")}
                inputlabelcolor={"#" + query.get("inputlabelcolor")}
                inputiconcolor={"#" + query.get("inputiconcolor")}
                inputerrorcolor={"#" + query.get("inputerrorcolor")}
                gradientcolor={query.get("gradientcolor")}
              />
            }
          />
        );
    }
  };

  const getLeftPageDesign = (value) => {
    switch (value) {
      case "design2":
        return (
          <LeftBarDesign2
            logo={query.get("logo")}
            gradientcolor={query.get("gradientcolor")}
            innerDesign={
              <LoginRegister
                page={value}
                logo={query.get("logo")}
                titlecolor={query.get("titlecolor")}
                inputlabelcolor={query.get("inputlabelcolor")}
                inputiconcolor={query.get("inputiconcolor")}
                inputerrorcolor={query.get("inputerrorcolor")}
                gradientcolor={query.get("gradientcolor")}
              />
            }
          />
        );
      case "design3":
        return (
          <LeftBarDesign3
            gradientcolor={query.get("gradientcolor")}
            innerDesign={
              <LoginRegister
                page={value}
                logo={query.get("logo")}
                titlecolor={query.get("titlecolor")}
                inputlabelcolor={query.get("inputlabelcolor")}
                inputiconcolor={query.get("inputiconcolor")}
                inputerrorcolor={query.get("inputerrorcolor")}
                gradientcolor={query.get("gradientcolor")}
              />
            }
          />
        );
      case "design4":
        return (
          <LeftBarDesign4
            gradientcolor={query.get("gradientcolor")}
            innerDesign={
              <LoginRegister
                page={value}
                logo={query.get("logo")}
                titlecolor={query.get("titlecolor")}
                inputlabelcolor={query.get("inputlabelcolor")}
                inputiconcolor={query.get("inputiconcolor")}
                inputerrorcolor={query.get("inputerrorcolor")}
                gradientcolor={query.get("gradientcolor")}
              />
            }
          />
        );
      case "design5":
        return (
          <LeftBarDesign5
            gradientcolor={query.get("gradientcolor")}
            innerDesign={
              <LoginRegister
                page={value}
                logo={query.get("logo")}
                titlecolor={query.get("titlecolor")}
                inputlabelcolor={query.get("inputlabelcolor")}
                inputiconcolor={query.get("inputiconcolor")}
                inputerrorcolor={query.get("inputerrorcolor")}
                gradientcolor={query.get("gradientcolor")}
              />
            }
          />
        );
      case "design6":
        return (
          <LeftBarDesign6
            logo={query.get("logo")}
            gradientcolor={query.get("gradientcolor")}
            innerDesign={
              <LoginRegister
                page={value}
                logo={query.get("logo")}
                titlecolor={query.get("titlecolor")}
                inputlabelcolor={query.get("inputlabelcolor")}
                inputiconcolor={query.get("inputiconcolor")}
                inputerrorcolor={query.get("inputerrorcolor")}
                gradientcolor={query.get("gradientcolor")}
              />
            }
          />
        );
      case "design7":
        return (
          <LeftBarDesign7
            gradientcolor={query.get("gradientcolor")}
            innerDesign={
              <LoginRegister
                page={value}
                logo={query.get("logo")}
                titlecolor={query.get("titlecolor")}
                inputlabelcolor={query.get("inputlabelcolor")}
                inputiconcolor={query.get("inputiconcolor")}
                inputerrorcolor={query.get("inputerrorcolor")}
                gradientcolor={query.get("gradientcolor")}
              />
            }
          />
        );
      case "design8":
        return (
          <LeftBarDesign8
            gradientcolor={query.get("gradientcolor")}
            innerDesign={
              <LoginRegister
                page={value}
                logo={query.get("logo")}
                titlecolor={query.get("titlecolor")}
                inputlabelcolor={query.get("inputlabelcolor")}
                inputiconcolor={query.get("inputiconcolor")}
                inputerrorcolor={query.get("inputerrorcolor")}
                gradientcolor={query.get("gradientcolor")}
              />
            }
          />
        );
      case "design9":
        return (
          <LeftBarDesign9
            gradientcolor={query.get("gradientcolor")}
            innerDesign={
              <LoginRegister
                page={value}
                logo={query.get("logo")}
                titlecolor={query.get("titlecolor")}
                inputlabelcolor={query.get("inputlabelcolor")}
                inputiconcolor={query.get("inputiconcolor")}
                inputerrorcolor={query.get("inputerrorcolor")}
                gradientcolor={query.get("gradientcolor")}
              />
            }
          />
        );
      case "design10":
        return (
          <LeftBarDesign10
            gradientcolor={query.get("gradientcolor")}
            innerDesign={
              <LoginRegister
                page={value}
                logo={query.get("logo")}
                titlecolor={query.get("titlecolor")}
                inputlabelcolor={query.get("inputlabelcolor")}
                inputiconcolor={query.get("inputiconcolor")}
                inputerrorcolor={query.get("inputerrorcolor")}
                gradientcolor={query.get("gradientcolor")}
              />
            }
          />
        );
      default:
        return (
          <LeftBarDesign1
            gradientcolor={query.get("gradientcolor")}
            innerDesign={
              <LoginRegister
                page={value}
                logo={query.get("logo")}
                titlecolor={query.get("titlecolor")}
                inputlabelcolor={query.get("inputlabelcolor")}
                inputiconcolor={query.get("inputiconcolor")}
                inputerrorcolor={query.get("inputerrorcolor")}
                gradientcolor={query.get("gradientcolor")}
              />
            }
          />
        );
    }
  };

  const getPageName = (name, page) => {
    let result = getHalfPageDesign(name);
    if (page === "page2") {
      result = getLeftPageDesign(name);
    }
    return result;
  };

  return <>{getPageName(name, page)}</>;
}
export default PreviewV1;
